import { render } from "./ImageEditor.vue?vue&type=template&id=4e568f44&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=ts"
export * from "./ImageEditor.vue?vue&type=script&lang=ts"

import "./ImageEditor.vue?vue&type=style&index=0&id=4e568f44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e568f44"

export default script